import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { injectIntl, FormattedMessage } from 'react-intl';
import defaultMsg from '../../translations/lang/en-US.json';

export function NotFound(props, context) {
  return (
    <div className="aligner">
      <div className="centerAligner">
        <Row>
          <Col md={6}>
            <div className="errorIcon">
              <img
                src={require('../../public/images/invalid.png')}
                alt="Invalid request"
              />
            </div>
          </Col>
          <Col md={6}>
            <h3><FormattedMessage id="error" defaultMessage={defaultMsg.error} /> {props.code || '404'}</h3>
            <p>
              {props.message || props.intl.formatMessage({ id: 'pageDoesnotExists', defaultMessage: defaultMsg.pageDoesnotExists })}
            </p>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default (injectIntl(NotFound));



// WEBPACK FOOTER //
// ./src/views/common/NotFound.jsx